// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"96147ded","199":"fd5f00f5","321":"2c6a2031","354":"aab3f0b6","501":"43be4ada","513":"8239bef3","600":"4ee9bada","669":"127037cc","675":"f7db59a9","849":"39280410","938":"b4b2991b","974":"b5b1179d","988":"ab1f3df9"}[chunkId] + ".chunk.js";
};